import { useEffect, useState } from "react";

// @mui material components
import Card from "@mui/material/Card";
import Collapse from "@mui/material/Collapse";
import Icon from "@mui/material/Icon";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 React examples
import DataTable from "examples/Tables/DataTable";

// Data
import data from "layouts/dashboard/components/Projects/data";

// Api
import MDAvatar from "components/MDAvatar";
import styled from "styled-components";
import getAssets from "layouts/dashboard/api/dashboardApi";
import { Pagination } from "@mui/material";

const HIDDEN_VALUE_LABEL = "****";
const HIDDEN_CURRENCY_LABEL = "R$ ****";
const HIDDEN_PERCENTAGE_LABEL = "****%";

function Projects({
  mobileCollapseEnabled = false,
  mobileExpanded = true,
  onToggleMobileCollapse,
  valuesHidden = false,
}) {
  const { columns, rows } = data();
  const [assets, setAssets] = useState([]);
  const [pageCount, setPageCount] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [orderBy, setOrderBy] = useState(null);
  const [orderDirection, setOrderDirection] = useState(null);

  const shouldShowContent = !mobileCollapseEnabled || mobileExpanded;

  useEffect(() => {
    //TODO: aqui chama a API para buscar a posição atual do user;
    getAssetsx();
  }, [, currentPage, orderBy, orderDirection]);


  const getAssetsx = async () => {
    setIsLoading((isLoading) => !isLoading)
    await getAssets(10, currentPage, orderBy, orderDirection).then((data) => {
      setAssets(data.results);
      setPageCount(data.pageCount);
      setIsLoading((isLoading) => !isLoading)
    });
  };

  const columnsx = [
    { Header: "Empresa", accessor: "logo", width: "25%", align: "left", },
    { Header: "Quantidade", accessor: "quantity", width: "25%", align: "center"},
    { Header: "Preço médio", accessor: "averagePrice", align: "center", blockSorting: false },
    { Header: "Valor de mercado", accessor: "marketPrice", align: "center", blockSorting: true },
    { Header: "Total", accessor: "total", align: "center", blockSorting: false },
    { Header: "Exposição na carteira", accessor: "walletPercentage", align: "center"}, //TODO: mudar isso pra subida ou descida do ativo
  ];

  const sortData = (val) => {
    if (val != orderBy) {
      setOrderBy(val);
      setOrderDirection('asc')
      return;
    }

    if (orderDirection == 'asc') {
      setOrderDirection('desc');
      return;
    }

    if (orderDirection == 'desc') {
      setOrderDirection(null);
      return;
    }

    if (orderDirection == null) {
      setOrderDirection('asc');
      return;
    }
  };


  const Company = ({ image, name }) => (
    <MDBox display="flex" alignItems="center" lineHeight={1}>
      <MDAvatar src={image} bgColor={'dark'} name={name} size="sm" />
      <MDTypography variant="button" fontWeight="medium" ml={1} lineHeight={1}>
        {name}
      </MDTypography>
    </MDBox>
  );

  const displayValue = (value) => (valuesHidden ? HIDDEN_VALUE_LABEL : value);
  const displayCurrency = (value) => (valuesHidden ? HIDDEN_CURRENCY_LABEL : `R$ ${value}`);
  const displayPercentage = (value) => (valuesHidden ? HIDDEN_PERCENTAGE_LABEL : `${value}%`);

  const rowsx = assets.map(e => (
    {
      logo: <Company image={e.logo} name={e.ticker} />,
      quantity: (
        <MDTypography variant="caption" color="text" fontWeight="medium">
          {displayValue(e.quantity)}
        </MDTypography>),
      averagePrice: (
        <MDTypography variant="caption" color="text" fontWeight="medium">
          {displayCurrency(e.averagePrice.toFixed(2))}
        </MDTypography>
      ),
      marketPrice: (
        <MDTypography variant="caption" color="text" fontWeight="medium">
          {e.marketPrice ? displayCurrency(e.marketPrice?.toFixed(2)) : '-'}
        </MDTypography>
      ),
      total: (
        <MDTypography variant="caption" color="text" fontWeight="medium">
          {displayCurrency(e.total.toFixed(2))}
        </MDTypography>
      ),
      walletPercentage: (
        <MDTypography variant="caption" color="text" fontWeight="medium">
          {displayPercentage(e.walletPercentage.toFixed(2))}
        </MDTypography>
      ),
    }
  ));

  return (
    <Card className="tabelaAtivos">
      <MDBox
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        px={mobileCollapseEnabled ? 2 : 3}
        py={mobileCollapseEnabled ? 2 : 3}
        onClick={mobileCollapseEnabled ? onToggleMobileCollapse : undefined}
        sx={
          mobileCollapseEnabled
            ? { cursor: "pointer", userSelect: "none", height: 58, boxSizing: "border-box" }
            : undefined
        }
      >
        <MDBox sx={{ flex: 1, minWidth: 0 }}>
          <MDBox display="flex" alignItems="center" lineHeight={0}>
            <MDBox display="flex" alignItems="center" gap={mobileCollapseEnabled ? 1.25 : 1}>
              <MDBox
                sx={{
                  width: 30,
                  height: 30,
                  borderRadius: "10px",
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: ({ palette: { info } }) => "rgba(26, 115, 232, 0.12)",
                  color: ({ palette: { info } }) => info.main,
                  flexShrink: 0,
                }}
              >
                <Icon fontSize="small">analytics</Icon>
              </MDBox>
              <MDTypography
                variant={mobileCollapseEnabled ? "h6" : "button"}
                fontWeight={mobileCollapseEnabled ? "medium" : "regular"}
                color={mobileCollapseEnabled ? undefined : "text"}
              >
                {mobileCollapseEnabled ? "Exposição atual por ativo" : <strong>Exposição atual por ativo</strong>}
              </MDTypography>
            </MDBox>
          </MDBox>
          <MDBox display="flex" alignItems="center" lineHeight={0}>

            {/* <MDTypography variant="button" fontWeight="regular" color="text">
              &nbsp;<strong>30 done</strong> this month
            </MDTypography> */}
          </MDBox>
        </MDBox>
        {mobileCollapseEnabled && (
          <Icon
            sx={{
              fontWeight: "bold",
              color: ({ palette: { info } }) => info.main,
            }}
            fontSize="small"
          >
            {mobileExpanded ? "expand_less" : "expand_more"}
          </Icon>
        )}
      </MDBox>
      <Collapse in={shouldShowContent} timeout="auto" unmountOnExit>
        <MDBox>
          <DataTable
            table={{ columns: columnsx, rows: rowsx }}
            showTotalEntries={false}
            isSorted={true}
            noEndBorder
            entriesPerPage={false}
            expandable
            sortData={sortData}
          />
        </MDBox>
        {pageCount > 1 && (
          <StyledPagination
            sx={{ display: 'flex', justifyContent: 'center', paddingTop: 4 }}
            disabled={isLoading}
            count={pageCount}
            boundaryCount={1}
            onChange={(e, page) => setCurrentPage(page)}
            size="small"
          />
        )}
      </Collapse>
    </Card>
  );
}

const StyledPagination = styled(Pagination)`
    .MuiPagination-ul button{
        background: radial-gradient(circle at 225% 577%, #f28371 0%, #f28371 84%, transparent 0%),#F0BA8E!important;
        opacity: 0.8; 

        &[disabled]{
            opacity: 0.4; 
        }

        &.Mui-selected {
            opacity: 0.9; 
            background: radial-gradient(circle at -136% 568%, #f28371 0%, #f28371 98%, transparent 0%),#F0BA8E!important
        }
    }

    .MuiPagination-ul li{
        padding: 0 2px;
    }

    margin-bottom: 30px
`;

export default Projects;
